export const ZOOM_CIRCLES_THRESHOLD = 4;
export const ZOOM_PLANT_THRESHOLD = 6;
export const ZOOM_BUILDING_THRESHOLD = 10; // previously 16
export const ZOOM_MAX_THRESHOLD = 18;
